import { useQuery } from '@tanstack/react-query';
import { CourseModel } from '../../../models/course.model';

export const useCourseSummary = (courseId: number) => {
  const { data, isLoading } = useQuery<CourseModel>(
    [`/courses/${courseId}/info`]
  );
  return { course: data, isFetchingCourse: isLoading };
};
